/**
 * Desktop entry — boots the Gridstack-canvas shell into #app.
 */
import "./styles/global.css";
import { renderApp } from "./App";

const root = document.getElementById("app");
if (!root) throw new Error("No #app root in DOM");
renderApp(root);
